import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { separateLeftRightSelectionState } from '@upright/ui/common/upright/core/impact-lens-profile/selection-state/separate-left-right-selection-state';
import { InsightsLensEmptyState } from '@upright/ui/common/upright/core/impact-lenses/insights/empty-state';
import { InsightsInfoBoxes } from '@upright/ui/common/upright/core/impact-lenses/insights/info-boxes';
import { InsightsInfoBoxConnectors } from '@upright/ui/common/upright/core/impact-lenses/insights/info-boxes/connectors';
import { isInsightsImpactBarClickable } from '@upright/ui/common/upright/core/impact-lenses/insights/selection-state';
import { insightsLensTexts } from '@upright/ui/common/upright/core/impact-lenses/insights/texts';
import { InsightsLensData, InsightsLensOptions } from '@upright/ui/common/upright/core/impact-lenses/insights/types';
import { ImpactLens, ImpactLensProfileLayer } from '@upright/ui/common/upright/core/impact-lenses/types';
import { ImpactBar } from '../../impact-lens-profile/common/components/data-area/impact-bars';

export const insightsLens: ImpactLens<ImpactLensType.INSIGHTS, InsightsLensData, InsightsLensOptions> = {
  type: ImpactLensType.INSIGHTS,
  ImpactDataComponent: {
    component: ImpactBar,
    layer: ImpactLensProfileLayer.SVG,
  },
  infoBoxes: {
    DivComponent: InsightsInfoBoxes,
    SvgComponent: InsightsInfoBoxConnectors,
  },
  boxMode: (fullWidth: number) => {
    if (fullWidth < 1000) {
      return LensBoxMode.MODAL;
    }
    return LensBoxMode.SIDE;
  },
  boxesAreaWidth: (_fullWidth: number) => {
    return 310;
  },
  EmptyState: InsightsLensEmptyState,
  isImpactDataAreaClickable: isInsightsImpactBarClickable,
  ...separateLeftRightSelectionState,
  ...insightsLensTexts,
};
